import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CodeOffIcon from '@mui/icons-material/CodeOff';

const ErrorFallback = () => {
  return (
    <Stack alignItems='center' margin='80px'>
      <CodeOffIcon sx={{ fontSize: '50px' }} />
      <Typography variant='h1'>Whoops, something went wrong.</Typography>
      <Typography variant='h2' marginBottom={2}>
        Please either refresh the page or return home to try again.
      </Typography>

      <Button
        color='primary'
        variant='contained'
        onClick={() => (window.location.href = '/')}
      >
        Go Home
      </Button>
    </Stack>
  );
};

export default ErrorFallback;
